import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Card, Button, Row, Col, Typography, Empty, Tag, Space } from "antd";
import { PlusOutlined, FileTextOutlined } from "@ant-design/icons";
import Utilities from "../../dependencies/custom/react-utilities";
import Settings from "../../dependencies/custom/settings";

const { Title, Text } = Typography;

export default function ApplicationDashboard() {
  const { state } = useLocation();
  // const [applications, setApplications] = useState(JSON.parse(localStorage.getItem("admissions") || "[]"));
  const [applications, setApplications] = useState([]);

  const navigate = useNavigate();
  useEffect(() => {
    boostrap();
  }, []);

  async function boostrap() {
    const res = await Utilities.fetchWithAuth(
      "GET",
      Settings.urls.enrollment?.related_applications,
      undefined,
      navigate,
    );
    if (res?.ok) {
      setApplications(res?.data);
    } else {
      Utilities.showNotification(undefined, res?.msg);
    }
  }

  async function printForm(app) {
    const res = await Utilities.fetchWithAuth(
      "GET",
      `${Settings.urls.enrollment?.applicationPrint}/${app?.admissionID}`,
      undefined,
      navigate,
    );
    if (res?.ok) {
      console.log(res?.data?.reportFile);
      // Utilities.openPdf(`${Settings.backend}/${res?.data?.reportFile}`);
      Utilities.openPdf(res?.data?.reportFile);
    } else {
      Utilities.showNotification(undefined, res?.msg);
    }
  }

  return (
    <div className="p-6">
      <div className="mb-3">
        <Title level={3}>My Application</Title>
        <Text type="secondary">
          Continue an existing application or start a new one.
        </Text>
      </div>

      <Row gutter={[16, 16]} className="mt-6">
        {/* New Application Card */}
        <Col xs={24} sm={12} md={8} lg={6}>
          <Card
            hoverable
            className="h-40 flex items-center justify-center rounded-2xl shadow"
            onClick={() =>
              navigate("../form", { state: { admissionData: null } })
            }
          >
            <div className="text-center">
              <PlusOutlined style={{ fontSize: 30 }} />
              <Title level={5} className="mt-2">
                Start New Application
              </Title>
            </div>
          </Card>
        </Col>

        {/* Existing Applications */}
        {applications.length === 0 ? (
          <Col span={24}>
            <Empty description="No applications yet" />
          </Col>
        ) : (
          applications?.map((app) => (
            <Col key={app?.admissionID} xs={24} sm={12} md={8} lg={6}>
              <Card
                hoverable
                className="rounded-2xl shadow"
                actions={[
                  app?.status === "ADMITTED" ? (
                    <Space>
                      <Button
                        onClick={() =>
                          navigate("../form", { state: { admissionData: app } })
                        }
                        style={{ borderColor: Utilities.getRandomColor() }}
                        icon={<i className="fas fa-eye" />}
                      >
                        View
                      </Button>
                      <Button
                        onClick={() => printForm(app)}
                        style={{ borderColor: Utilities.getRandomColor() }}
                        icon={<i className="fas fa-print" />}
                      >
                        Print
                      </Button>
                    </Space>
                  ) : parseInt(app?.locked) ? (
                    <Button
                      onClick={() => printForm(app)}
                      style={{ borderColor: Utilities.getRandomColor() }}
                      icon={<i className="fas fa-print" />}
                    >
                      Print
                    </Button>
                  ) : (
                    <Button
                      onClick={() =>
                        navigate("../form", { state: { admissionData: app } })
                      }
                      style={{ borderColor: Utilities.getRandomColor() }}
                      icon={<i className="fas fa-redo" />}
                    >
                      Continue
                    </Button>
                  ),
                ]}
              >
                <FileTextOutlined style={{ fontSize: 26 }} />
                <Title level={5} className="mt-3">
                  {app?.student?.firstName} {app?.student?.lastName} -{" "}
                  {app?.student?.className}
                </Title>
                <Tag color={Utilities.getRandomColor()}>
                  <Text className="text-white">Status: {app?.status}</Text>
                </Tag>
                <Text className="text-white">ID: {app?.status}</Text>
                <br />
                <Text type="secondary">Date: {app?.dateSubmitted}</Text>
              </Card>
            </Col>
          ))
        )}
      </Row>
    </div>
  );
}
